import { IUsersTabModel } from "@/Administration/Models/UI/Users/IUsersTabModel";
import { Popup } from "@/Common/Components/Modals/Popup";
import { ChangePasswordPopupControl } from "@/Common/Components/Password/ChangePasswordPopupControl";
import { PinControl } from "@/Common/Components/Sign/PinControl";
import { ServiceComboDefinitionModel } from "@/Common/Models/Services/ServiceComboDefinitionModel";
import { ServiceDefinitionModel } from "@/Common/Models/Services/ServiceDefinitionModel";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { Dispatcher } from "@/Common/Stores/Dispatcher";
import { CreateNewEmployeeComponent } from "./CreateEmployeeComponent";
import { UserDetailsPanelComponent } from "./UserDetailsPanelComponent";
import { UserSearchComponent } from "./UserSearchComponent";

interface IUsersAdminTabProps {
    usersTabModel: IUsersTabModel;
    serviceDefinitionCache: Immutable.List<ServiceDefinitionModel>;
    serviceComboDefinitionCache: Immutable.List<ServiceComboDefinitionModel>;
}

class UsersAdminTab extends React.Component<IUsersAdminTabProps, never> {
    public componentDidUpdate(): void {
        $(window).trigger("resize");
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public render(): JSX.Element {
        let searchUserModel = this.props.usersTabModel.get("UsersSearchModel");
        let selectedEmployee = (this.props.usersTabModel) ? this.props.usersTabModel.get("SelectedEmployee") : null;

        return (
            <div className="fxheight">
                <div className="admin-users-container">

                    {this.props.usersTabModel.get("SearchMenuOpen") === true && (
                        <UserSearchComponent
                            userSearchModel={administrationStore.usersTabModel.get("UsersSearchModel")}
                            operation={LocalOperations.AdministrationUsers.GetAllEmployeeSearch}
                            selectedEmployee={selectedEmployee}
                        />
                    )}

                    {this.props.usersTabModel.get("CreatePopupOpen") === true && (
                        <Popup
                            cssClass="centered-popup width-800"
                            title={cacheStore.GetString("CreateNewEmployeeLabel")}
                            closeTarget={LocalOperations.AdministrationUsers.CloseCreateEmployeePopup}
                            dataCy="userProfile-createPopup"
                        >
                            <CreateNewEmployeeComponent
                                closePopupOperation={LocalOperations.AdministrationUsers.CloseCreateEmployeePopup}
                                createClericalAccountOperation={LocalOperations.AdministrationUsers.CreateClericalEmployee}
                                createClinicalAccountOperation={LocalOperations.AdministrationUsers.CreateClinicalEmployee}
                            />
                        </Popup>
                    )}

                    <div className="aside-handle responsive" onClick={this.toggleSearchMenu.bind(this)}> <div className="slide-menu-icon blue d"><span /><span /><span /></div></div>

                    {searchUserModel.get("ReinitPopupOpen") && (
                        <ChangePasswordPopupControl
                            popupTitle={cacheStore.GetString("ChangePasswordLabel")}
                            isAdminReset={true}
                            isAdminResetEmployeeId={searchUserModel.get("SelectedEmployeeId")}
                            bypassComplexityValidation={true}
                            onClosePopupCallBack={() => Dispatcher.dispatch(LocalOperations.AdministrationUsers.ReinitUsersPopupClose)}
                            onSuccess={() => Dispatcher.dispatch(LocalOperations.AdministrationUsers.ReinitUsersPopupClose)}
                        />
                    )}

                    {this.props.usersTabModel.get("IsModifyPinMode") === true && (
                        <Popup cssClass="centered-popup width-400" title={cacheStore.GetString("PINLabel")} closeTarget={LocalOperations.AdministrationUsers.CloseModifyPinPopup}>
                            <PinControl
                                pinRequired={false}
                                isAdminReset={true}
                                isAdminResetEmployeeId={(selectedEmployee) ? selectedEmployee.Model.User_id : ""}
                                onClosePopupCallBack={() => Dispatcher.dispatch(LocalOperations.AdministrationUsers.CloseModifyPinPopup)}
                            />
                        </Popup>
                    )}

                    <UserDetailsPanelComponent
                        model={this.props.usersTabModel}
                        serviceDefinitionCache={this.props.serviceDefinitionCache}
                        serviceComboDefinitionCache={this.props.serviceComboDefinitionCache}
                    />

                </div>
            </div>
        );
    }

    private toggleSearchMenu(): void {
        let operation = this.props.usersTabModel.get("SearchMenuOpen") === true ? LocalOperations.AdministrationUsers.ToggleUserSearchSideBar : LocalOperations.AdministrationUsers.ToggleUserSearchSideBar;
        LocalEvent.Dispatch(operation);
    }
}

export { UsersAdminTab };
